<p-toast [baseZIndex]="5000"></p-toast>
<!-- Global Upload Status Component -->
<app-global-upload-status></app-global-upload-status>
<!-- <app-main-page></app-main-page> -->
<router-outlet></router-outlet>

